/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Row, Col, Spin } from 'antd';

import PageTitle from '../PageTitle';

import s from './styles.module.less';

const CenteredMessage = ({ loader, children, ...props }) => (
  <Row align="middle" justify="center" gutter={30} className={s.root}>
    {children && (
      <Col>
        <PageTitle {...props}>{children}</PageTitle>
      </Col>
    )}
    {loader && (
      <Col>
        <Spin size="large" />
      </Col>
    )}
  </Row>
);

export default CenteredMessage;
